import { Link } from "react-router-dom";
import { Compass } from "lucide-react";

const NotFoundPage = () => (
  <section className="mx-auto flex min-h-[60vh] max-w-xl flex-col items-center justify-center text-center" data-testid="authenticated-not-found">
    <div className="mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-primary/10 text-primary">
      <Compass aria-hidden="true" />
    </div>
    <p className="text-sm font-semibold uppercase tracking-[0.18em] text-primary">404</p>
    <h1 className="mt-2 text-3xl font-bold font-heading">Page not found</h1>
    <p className="mt-3 text-muted-foreground">
      This address is not part of the OMNΛS workspace. Your project data has not changed.
    </p>
    <Link
      to="/dashboard"
      className="mt-6 inline-flex h-10 items-center justify-center rounded-md bg-primary px-4 text-sm font-medium text-primary-foreground hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
    >
      Return to Dashboard
    </Link>
  </section>
);

export default NotFoundPage;
